var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetpardyCapPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 368,
    viewBox: "0 0 545 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.425 19.3298H24.8601V344.504H521.425V19.3298Z",
    fill: "#3600D0",
    stroke: "#9069FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255 75V242.476H277V75H255Z",
    fill: "#9069FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255 261.575H277V277H255V261.575Z",
    fill: "#9069FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255 75V242.476H277V75H255Z",
    stroke: "#9069FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255 261.575H277V277H255V261.575Z",
    stroke: "#9069FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetpardyCapPressed);
export default __webpack_public_path__ + "static/media/netpardy-cap-pressed.f91a653083789ca991231c232655a920.svg";
export { ForwardRef as ReactComponent };